// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MI1on","questions":"styles_questions__H35-m","footer":"styles_footer__1fUUZ"};